module.exports = __webpack_public_path__ + "img/minimize.99224878.svg";